<div class="searchable-selection-wrapper">
  <div class="search-input-wrapper" [class.selected-tag]="!!selectedItem">
    <input
      type="text"
      [(ngModel)]="searchTerm"
      (input)="onSearchChange()"
      (focus)="onFocus()"
      (blur)="onBlur()"
      (keydown)="onKeydown($event)"
      [placeholder]="placeholder"
      class="search-input"
      [class.show-dropdown]="showDropdown"
      [class.has-selection]="!!selectedItem"
      [readonly]="!!selectedItem"
      [disabled]="disabled">
    <button
      *ngIf="selectedItem && searchTerm"
      class="clear-search-btn"
      (click)="clearSelection(); $event.stopPropagation()"
      type="button"
      title="Clear selection">
      ✕
    </button>

    <!-- Dropdown list -->
    <div *ngIf="showDropdown" class="selection-dropdown" (click)="$event.stopPropagation()" (mousedown)="$event.preventDefault(); $event.stopPropagation()">
      <div
        *ngFor="let item of filteredItems; trackBy: trackByValue"
        class="dropdown-item"
        (click)="selectItem(item); $event.stopPropagation()"
        (mousedown)="$event.preventDefault(); $event.stopPropagation()"
        [class.selected]="selectedItem && selectedItem[valueProperty] === item[valueProperty]">
        <span class="item-name">{{ getDisplayValue(item) }}</span>
        <span *ngIf="showValueProperty" class="item-value">{{ formatValue(item) }}</span>
      </div>
      <div *ngIf="filteredItems.length === 0 && searchTerm.trim()" class="no-items-message">
        No items found
      </div>
      <div *ngIf="filteredItems.length === 0 && !searchTerm.trim() && !serverSideSearch" class="no-items-message">
        No items available
      </div>

      <div *ngIf="allowAddNew" class="dropdown-footer">
        <button
          type="button"
          class="add-new-btn"
          (click)="requestAddNew(); $event.stopPropagation()"
          (mousedown)="$event.preventDefault()">
          {{ addNewLabel }}
        </button>
      </div>
    </div>
  </div>
</div>

